export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_38-3568bd55540ba26c653a23feb0023a39.jpg";